var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"popover"},[_c('gl-badge',{attrs:{"variant":"neutral","icon":"bulb"}}),_vm._v(" "),_c('gl-popover',{attrs:{"target":() => _vm.$refs.popover,"placement":"top","title":_vm.$options.i18n.title,"content":_vm.$options.i18n.message}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }